// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3qctz","notes":"Notes_notes__1Vuw6"};